<script lang="ts" setup>
interface GameVoteCardProps {
  game: GalGame;
  text?: string;
}

const props = defineProps<GameVoteCardProps>();
</script>
<template>
  <div class="flex gap-3">
    <div class="flex-1 flex flex-col gap-1">
      <div class="line-clamp-1 text-base">{{ game.name }}</div>
      <div class="flex flex-col gap-1 text-xs text-base-content/50">
        <div class="line-clamp-1">
          {{ `${$t("game.producer")}: ${game.mate?.name}` }}
        </div>
        <div class="line-clamp-2">
          {{ `${$t("game.base.type")}: ${$t(`game.type.${game.type}`)}` }}
        </div>
      </div>
    </div>
    <div class="w-40 aspect-[16/9] rounded overflow-hidden">
      <BaseImg :media="game.coverMedia" ratio="16/9" />
    </div>
  </div>
  <!--  <div class="rounded bg-neutral p-2 flex justify-between items-center">-->
  <!--    <span>1月(上) 排行榜：<span class="text-primary">49名</span></span>-->
  <!--    <span class="btn btn-xs btn-ghost text-base-content/50">-->
  <!--      查看全部排名-->
  <!--      <light-arrow-icon class="icon-xs transform rotate-180" />-->
  <!--    </span>-->
  <!--  </div>-->
  <div
    v-if="text"
    class="text-base-content/50 mt-4"
    v-html="$t('Coin.' + text, { name: game.name })"
  ></div>
</template>
